<div class="page-layout">
  <p class="head-text" *ngIf="portfolioTarget">
    <span class="portfolio-activity-teacher-info">
      <span class="teacher-name fw-bold">{{ portfolioTarget.teacherFirstName }} {{ portfolioTarget.teacherLastName }}</span>
      <span class="grey-text">
        <span class="mx-2">•</span>
        <span>{{ portfolioTarget.teacherGroups | formatTeacherGroups }}</span>
      </span>
    </span>
  </p>
  <div class="plan-detail d-flex flex-wrap flex-xl-nowrap flex-column-reverse flex-xl-row" *transloco="let t" [formGroup]="form">
    <div *ngIf="portfolioTarget; else loading" class="target-list d-flex flex-column">
      <isophi-app-portfolio-plan-description
        [control]="form.controls.description"
        [title]="t('pap/plan/description')"
        [allowEditMode]="false"
      ></isophi-app-portfolio-plan-description>
      <isophi-app-portfolio-plan-competence
        [control]="form.controls.competenceUuids"
        [fetchCategories]="fetchCategories"
        [materialServer]="materialServer"
        [allowEditMode]="false"
      ></isophi-app-portfolio-plan-competence>
      <isophi-app-portfolio-plan-planned
        [plannedActivities]="portfolioTarget?.plannedActivities"
        [allowEditMode]="false"
      ></isophi-app-portfolio-plan-planned>
      <isophi-app-portfolio-plan-linked-activites
        [teacherTargetId]="portfolioTargetId"
        [allowEditMode]="false"
        [fetchTeacherActivityTargetLinks]="fetchPortfolioActivityTargetLinks"
        [fetchTeacherActivities]="fetchPortfolioActivities"
        [buildTeacherActivityRouteLink]="buildPortfolioActivityRouteLink"
      ></isophi-app-portfolio-plan-linked-activites>
    </div>
    <ng-template #loading>
      <div class="text-center w-100 mt-4">
        <div class="spinner-border" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </ng-template>
    <div class="target-description d-flex flex-column">
      <div class="target-description-header">
        <div class="target-state" [ngClass]="getTargetStateClass(portfolioTarget?.state)">
          {{ targetStateData[portfolioTarget?.state] }}
        </div>
        <button (click)="printPage()" class="btn btn-outline-primary btn-icon target-print-button">
          <isophi-print-download-icon class="print-icon"></isophi-print-download-icon>
          {{ t('shared/printDownload') }}
        </button>
      </div>
      <div class="target-info">
        <div class="info-item">
          <div class="info-title">{{ t('pap/plan/fulfillmentDate') }}</div>
          <div class="info-content">
            <span class="material-symbols-rounded"> flag_2 </span>
            {{ portfolioTarget?.fulfillmentDate | date : 'd. M. y' }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">{{ t('pap/plan/duration') }}</div>
          <div class="info-content">
            <span class="material-symbols-rounded"> hourglass </span>
            {{ portfolioTarget?.estimatedTime }} {{ t('shared/hours') }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">{{ t('pap/plan/supportType') }}</div>
          <div class="info-content">
            <span class="material-symbols-rounded"> volunteer_activism </span>
            {{ supportTypeData[portfolioTarget?.supportType] }}
          </div>
        </div>
        <div class="info-item">
          <div class="info-title">{{ t('pap/plan/createdDate') }}</div>
          <div class="info-content">
            <span class="material-symbols-rounded"> edit_square </span>
            {{ portfolioTarget?.created | date : 'd. M. y' }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
